const letsTry = (text) => {
  console.log(`Let's try some ECMAScript 6 in contact site! ${text}`)
}

letsTry('It\'s really cool!')



/** WEBPACK FOOTER **
 ** ./assets/scripts/contact.js
 **/